var _excluded = ["className", "children", "onContainerSize", "variant"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import InverseContext from '../../utilities/inverse-context';
import PropTypes from 'prop-types';
import Type from '../type';
import StyledBox from './box.styles';
import ContainerQuery from './../container-query';
import { StyledCacheWrapper } from '../../styles';
import withDeprecatedProps from '../../utilities/with-deprecated-props/withDeprecatedProps';
var boxPropsTypes = {
  /** Add custom CSS classes to component. */
  className: PropTypes.string,
  /** Box Content */
  children: PropTypes.node,
  /** Box padding density */
  density: PropTypes.oneOf(['comfortable', 'compact', 'flush']),
  /** Add/Remove a border */
  hasBorder: PropTypes.bool,
  /**
   * @deprecated since 2.52.0
   * @see hasBorder
   */
  isBordered: PropTypes.bool,
  /** Box background color variant */
  variant: PropTypes.oneOf(['light', 'gray', 'dark']),
  /** Add utility objects for styling */
  utils: PropTypes.object,
  /** Callback for when component resizes */
  onContainerSize: PropTypes.func
};
var boxPropsDefault = {
  className: '',
  children: /*#__PURE__*/React.createElement(Type, {
    element: "p"
  }, "Box Content"),
  density: 'comfortable',
  hasBorder: true,
  isBordered: null,
  variant: 'light',
  utils: {},
  onContainerSize: function onContainerSize() {}
};

/**
 * @ignore @description
 * ## Box Component
 * Boxes are containers that can contain controls and content inside them and are preferred to be used inside the tile and card components.
 *
 * @ignore @see Mesh: [Box Docs](https://mesh-component-library.apps.csts-k8cnp-ro-1.r-caas.allstate.com/?path=/story/containers-box--default)
 *
 * @ignore @example
 * ```jsx
 * import { Box } from 'mesh-component-library';
 *
 * <Box {...props}>
 *  {children}
 * </Box>
 * ```
 */

export var Box = function Box(props) {
  var className = props.className,
    children = props.children,
    onContainerSize = props.onContainerSize,
    variant = props.variant,
    other = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(StyledCacheWrapper, null, /*#__PURE__*/React.createElement(ContainerQuery, {
    onContainerSize: onContainerSize
  }, /*#__PURE__*/React.createElement(StyledBox, _extends({}, other, {
    variant: variant,
    className: className
  }), /*#__PURE__*/React.createElement(InverseContext.Provider, {
    value: variant === 'dark'
  }, children))));
};
Box.propTypes = boxPropsTypes;
Box.defaultProps = boxPropsDefault;
Box.displayName = 'Box';

/**
 * @type React.FC<boxPropsTypes>
 */
export default withDeprecatedProps(Box);